module.exports = __webpack_public_path__ + "static/media/activeDrawIcon.8891108c.svg";